export default[
	{
		path: "/ecology",
		component: () => import("../../components/main.vue"),
		meta: {
			title: 'RPA生态'
		},
		children:[
			{
				path:'course',
				component: () => import("../../components/ecology/course/index.vue"),
				meta: {
					title: '培训课程'
				}
			},{
				path:'doc',
				component: () => import("../../components/ecology/doc/index.vue"),
				meta: {
					title: '产品文档'
				}
			}
		]
	}
]
